import React, {FC} from 'react';

export const SubTitle: FC<any> = (props) => {
    return (
        <div className="mb-0.5 font-bold text-2xl">
            {props.children}
            <br/>
        </div>
    );
};
